import { METHOD } from '../utils/Constant';
import { URL } from '../utils/Config';
import { getApiClient, getFullAuthHeaders } from './base';
export const getMarketingEmployeeList = (params: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.MARKETING_ACTIVITY_API_URL
  )({
    method: METHOD.GET,
    url: URL.MA_EMPLOYEE_LIST,
    params,
  });
};

export const getMarketingActivities = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.MARKETING_ACTIVITY_API_URL
  )({
    method: METHOD.POST,
    url: URL.MA_LIST,
    data,
  });
};

export const getDetailedMarketingActivity = (params: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.MARKETING_ACTIVITY_API_URL
  )({
    method: METHOD.GET,
    url: URL.DETAILED_MA,
    params,
  });
};

export const createNewMarketingActivity = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.MARKETING_ACTIVITY_API_URL
  )({
    method: METHOD.POST,
    url: URL.CREATE_MA,
    data,
  });
};

export const approveRejectMarketingActivity = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.MARKETING_ACTIVITY_API_URL
  )({
    method: METHOD.PUT,
    url: URL.APPROVE_REJECT_MA,
    data,
  });
};
export const removeAssigneeMarketingActivity = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.MARKETING_ACTIVITY_API_URL
  )({
    method: METHOD.POST,
    url: URL.REMOVE_ASSIGNEE_MA,
    data,
  });
};

export const addAssigneesMarketingActivity = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.MARKETING_ACTIVITY_API_URL
  )({
    method: METHOD.POST,
    url: URL.ADD_ASSIGNEES_MA,
    data,
  });
};
export const updatePrimaryEmployee = (data: any) => {
  return getApiClient(
    getFullAuthHeaders(),
    URL.MARKETING_ACTIVITY_API_URL
  )({
    method: METHOD.POST,
    url: URL.UPDATE_PRIMARY_EMPLOYEE,
    data,
  });
};
